import type { Result } from '@finn-no/search-frontend-clients/suggest';
import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultOption } from './ResultOption';
import type { ActionFunction, ResultsProps } from './ResultTypes';
import { SelectAction } from './ResultTypes';

const SHOW_SAVED_SEARCHES_RESULT = {
    resultType: 'SAVEDSEARCH',
} as Result;

export const savedSearchResultsAction: ActionFunction = ({
    config,
    metaData,
    result,
}) => {
    if (result === SHOW_SAVED_SEARCHES_RESULT) {
        const { siteUrl } = config;
        const savedSearchUrl = `${siteUrl}/savedsearches`;
        window.location.href = savedSearchUrl;
    } else {
        trackResultClick(result, metaData.tracking);
        window.location.href = result.url;
    }
    return SelectAction.CLOSE;
};

export function SavedSearchResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    const showSavedSearchesOption = (
        <ResultOption className="mt-4" result={SHOW_SAVED_SEARCHES_RESULT}>
            {() => <a className="text-12 font-bold">Vis alle lagrede søk</a>}
        </ResultOption>
    );

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            <div className="grid md:grid-cols-2 gap-2 -mx-8">
                {resultGroup.results.map((result) => {
                    const imageSrc = getImageSrc(result);

                    return (
                        <ResultOption
                            key={`${result.resultType}-${result.order}-${resultId}`}
                            result={result}
                        >
                            {({ active, ariaLabel }) => (
                                <a
                                    aria-label={ariaLabel}
                                    className={`link link--dark grid grid-rows-2 grid-cols-2 gap-x-8 p-8 rounded-8 border ${
                                        active
                                            ? 'border-bluegray-300 bg-bluegray-100'
                                            : 'border-transparent'
                                    }`}
                                    style={{
                                        gridTemplateColumns: 'min-content 1fr',
                                    }}
                                >
                                    <img
                                        className="row-span-2 max-w-min"
                                        src={imageSrc}
                                        width="40"
                                        height="40"
                                    />
                                    <span className="text-14 overflow-hidden overflow-ellipsis whitespace-nowrap">
                                        {result.title}
                                    </span>
                                    <span className="text-12 text-gray-500">
                                        {result.secondaryTitle}
                                    </span>
                                </a>
                            )}
                        </ResultOption>
                    );
                })}
            </div>
            {showSavedSearchesOption}
        </ResultGroup>
    );
}

function getImageSrc(result: Result) {
    const image = result.imageId ? result.imageId : 'finn';
    return `https://static.finncdn.no/_c/static/search-assets/newfrontier/${image}.png`;
}
